type Listener = (reason: string) => void;

const listeners = new Set<Listener>();

export function notifySessionExpired(reason: string): void {
  listeners.forEach((listener) => listener(reason));
}

export interface SessionExpiredSubscription {
  unsubscribe: () => void;
}

export function onSessionExpired(listener: Listener): SessionExpiredSubscription {
  listeners.add(listener);
  return { unsubscribe: () => listeners.delete(listener) };
}
